// Formats a counter value for compact badge display. Any value above `max`
// collapses to `${max}+` (e.g. 100 -> "99+") so that three-digit counters do
// not blow out the sidebar/badge layout. Pass `max={Infinity}` to show the
// exact value (e.g. tabular data where magnitude matters). Non-numeric input
// is returned unchanged.
export function formatCountBadge(value, max = 99) {
  const n = Number(value);
  if (!Number.isFinite(n)) return value;
  if (n > max) return `${max}+`;
  return n;
}

export default formatCountBadge;
